const API = {
  WAREHOUSE: "/web/v3/warehouse/main",
};

export default API;
